exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/my-purchases-graphql.js-WebpackMultiOutput";